import get from 'lodash/get';
import triggerTracking from '@blueprint/tracking';
import { InternalPromoId } from './index';
import { ProductTrackingObject } from '@zoopla/listing-search-context';

const getVariant = (featuredType?: string | null): string => {
    const featuredTypeToVariant = {
        featured: 'Featured',
        weekly_featured: 'Weekly Featured'
    };

    const defaultVariant = featuredTypeToVariant.featured;

    return get(featuredTypeToVariant, featuredType ?? '', defaultVariant);
};

const getPromoCategory = (item: string) => {
    const promoTypeToCategory = {
        mobile: 'app_in_wfp',
        smartmap: 'map_in_wfp',
        newhomes: 'nh_in_wfp'
    };

    return get(promoTypeToCategory, item);
};

export type Product =
    | {
          listingId: string;
          featuredType?: string | null;
          title?: string | null;
          price?: string | null;
          alternativeRentFrequencyLabel?: string | null;
          address?: string | null;
          branch?: { logoUrl?: string | null; name?: string | null } | null;
          listingUris?: {
              detail?: string | null;
          } | null;
          features?:
              | ({
                    iconId?: string | null;
                    content?: number | null;
                } | null)[]
              | null;
          image?: {
              src?: string | null;
              responsiveImgList?:
                  | ({ src?: string | null; width?: number | null } | null)[]
                  | null;
          } | null;
      }
    | InternalPromoId;

export const getProductImpression = (
    item: Product,
    position: number,
    listName = 'Featured listings'
): ProductTrackingObject => {
    if (typeof item === 'string') {
        return {
            id: 'Unfilled',
            list: listName,
            position: position,
            variant: item
        };
    }
    return {
        id: item.listingId,
        list: listName,
        position: position,
        variant: getVariant(item.featuredType)
    };
};

export const trackFeaturedPropertyImpressions = (
    displayedItems: Product[]
): void => {
    const impressions = displayedItems
        .map((item, index) => getProductImpression(item, index + 1))
        .filter((impression) => impression.id === 'Unfilled');

    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            impressions
        }
    });
};

export const getOnClickTracking =
    (item: Product, index: number): (() => void) =>
    () => {
        if (item === 'mobile' || item === 'smartmap' || item === 'newhomes') {
            triggerTracking({
                event: 'GAEvent',
                eventAction: 'Click',
                eventCategory: getPromoCategory(item)
            });
            return;
        }

        const { id, list, position, variant } = getProductImpression(
            item,
            index + 1
        );

        triggerTracking({
            event: 'GAEventEcommerce',
            ecommerce: {
                click: {
                    actionField: {
                        list
                    },
                    products: [
                        {
                            id,
                            position,
                            variant
                        }
                    ]
                }
            }
        });
    };
